module.exports = __webpack_public_path__ + "static/media/Y.748524ec.jpg";